import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { useCallback } from "react";
import { Button } from "../../uiLibrary/button";
import { locationPrepend } from "../../other/devServer/locationPrepend";

export const DemoConsolePage = () => {
    const click = useCallback(
        () =>
            window.open(
                `${locationPrepend()}/DemoConsole`,
                "DemoConsole",
                "left=100,top=100,width=550,height=600,resizable=0"
            ),
        []
    );

    return (
        <BannerPage title="Demo console">
            <Button
                buttonType="neutral"
                testId="openDemoConsole"
                onClick={click}
            >
                Open demo console
            </Button>
        </BannerPage>
    );
};
